module.exports = __webpack_public_path__ + "img/CU.41346d9a.svg";